import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleInvoiceBranchURL = `api/v1/sales-app/sales-invoice/branch/sales-order`;

//obtaining the paginated data
export const getSaleInvoiceBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleInvoiceBranchURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleInvoiceBranch = () => axiosInstance.get(`${saleInvoiceBranchURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleInvoiceBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${saleInvoiceBranchURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

// get by id
export const getSaleInvoiceBranchById = (id) => axiosInstance.get(`${saleInvoiceBranchURL}/retrieve/${id}`);

//get sale detail from grn
export const getSaleOrderDetail = (id) => axiosInstance.get(`api/v1/sale-app/grn/retrieve/${id}`);

//creating function
export const createSaleInvoiceBranch = (body) =>
  axiosInstance.post(`api/v1/sales-app/sales-invoice/branch/create`, body);
//updating function
export const updateSaleInvoiceBranch = (id, body) => axiosInstance.patch(`${saleInvoiceBranchURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleInvoiceBranchURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
